import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GridContextMenuItem } from '../../components/wc-grid/wc-grid.component';
import { EventPayloadDialogComponent } from '../../utility/event-payload-dialog/event-payload-dialog.component';

@Component({
  selector: 'app-task-event-history',
  standalone: false,
  templateUrl: './task-event-history.component.html',
  styleUrl: './task-event-history.component.css'
})
export class TaskEventHistoryComponent {
  readonly menuItems: GridContextMenuItem[] = [
    { id: 'viewPayload', label: 'View Payload' }
  ];

  constructor(private dialog: MatDialog) {}

  onGridAction(event: { id: string; row: Record<string, any> }): void {
    if (event.id !== 'viewPayload') return;
    this.dialog.open(EventPayloadDialogComponent, {
      data: { payload: event.row['Payload'] ?? null },
      minWidth: 500,
      maxWidth: 800,
    });
  }
}
